import {all} from 'redux-saga/effects';

import {addVenueSagaWatcher} from './add_venue.saga';
import {addVenueLogSagaWatcher} from './add_venue_log.saga';
import {deleteVenueLogSagaWatcher} from './delete_venue_log.saga';
import {bulkUpdateVenuesSagaWatcher} from './bulkupdate_venues.saga';
import {changeVenueAliasSagaWatcher} from './change_venue_alias.saga';
import {changeVenueEmailSagaWatcher} from './change_venue_email.saga';
import {deleteVenueSagaWatcher} from './delete_venue.saga';
import {getVenueSagaWatcher} from './get_venue.saga';
import {getVenueByIdSagaWatcher} from './get_venue_by_id.saga';
import {getVenuesSagaWatcher} from './get_venues.saga';
import {getAllVenuesSagaWatcher} from './get_all_venues.saga';
import {getVenuesStatusesSagaWatcher} from './get_venues_statuses.saga';
import {controlVenueStatusesSagaWatcher} from './control_venue_statuses.saga';
import {setSelectedVenueSagaWatcher} from './set_selected_venue.saga';
import {getVenuesWithInRangeSagaWatcher} from './get_venues_withinrange.saga';
import {updateVenueSagaWatcher} from './update_venue.saga';
import {updateVenueStatusesSagaWatcher} from './update_venue_statuses.saga';
import {updateVenueStatusesWithFirebaseSagaWatcher} from './update_venue_statuses_with_firebase.saga';
import {updateVenueDeliveryAreasSagaWatcher} from './update_venue_deliveryareas.saga';

export default function* venueSaga() {
  yield all([
    addVenueSagaWatcher(),
    addVenueLogSagaWatcher(),
    deleteVenueLogSagaWatcher(),
    bulkUpdateVenuesSagaWatcher(),
    changeVenueAliasSagaWatcher(),
    changeVenueEmailSagaWatcher(),
    deleteVenueSagaWatcher(),
    getVenueSagaWatcher(),
    getVenueByIdSagaWatcher(),
    getVenuesSagaWatcher(),
    getAllVenuesSagaWatcher(),
    getVenuesStatusesSagaWatcher(),
    controlVenueStatusesSagaWatcher(),
    setSelectedVenueSagaWatcher(),
    getVenuesWithInRangeSagaWatcher(),
    updateVenueSagaWatcher(),
    updateVenueStatusesSagaWatcher(),
    updateVenueStatusesWithFirebaseSagaWatcher(),
    updateVenueDeliveryAreasSagaWatcher(),
  ]);
}
